var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('js-header'),_c('js-navigation-header'),_c('js-navigation-sp-mask'),_c('div',{staticClass:"l-wrapper",attrs:{"id":"js-wrapper"}},[_c('breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('js-hero'),_c('router-view'),_c('js-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }